import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSecurityShield = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>SecurityShield</title>
    <path
      clipRule="evenodd"
      d="M5.027 8.91C9.904 8.29 16 2.7 16 2.7s6.096 5.59 10.972 6.21v9.816c0 3.553-1.833 6.854-4.849 8.732L16 31.27l-6.124-3.813a10.286 10.286 0 0 1-4.849-8.732V8.91Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m11.439 18.249 3.414 3.414 6.827-8.876"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoSecurityShield;
